import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { SlideBlockContext } from "../SlideBlock";

/*
 * MainTitle
 *  - Component that display the H1 title of Design Section
 */
export function MainTitle({ title }) {
  const { getTabIndex } = React.useContext(SlideBlockContext);

  return (
    <h1 tabIndex={getTabIndex} className={style.designView_left_title}>
      {title}
    </h1>
  );
}

MainTitle.propTypes = {
  /*
   * Main title for the design section
   */
  title: PropTypes.string.isRequired,
};

MainTitle.defaultProps = {
  title: "",
};
